import { ColumnId, JobId, OrganizationId, UserId, V1ProjectId, V2ColumnId, V2ProjectId } from "@wise/identities"
import superjson from "superjson"

superjson.registerCustom<ColumnId, string>(
    {
        isApplicable: ColumnId.isColumnId,
        serialize: (id) => id.toUrl(),
        deserialize: (url) => ColumnId.fromUrl(url),
    },
    "ColumnId"
)
superjson.registerCustom<V2ColumnId, string>(
    {
        isApplicable: V2ColumnId.isColumnId,
        serialize: (id) => id.toUrl(),
        deserialize: (url) => V2ColumnId.fromUrl(url),
    },
    "V2ColumnId"
)
superjson.registerCustom<JobId, string>(
    {
        isApplicable: JobId.isJobId,
        serialize: (id) => id.toUrl(),
        deserialize: (url) => JobId.fromUrl(url),
    },
    "JobId"
)
superjson.registerCustom<OrganizationId, string>(
    {
        isApplicable: OrganizationId.isOrganizationId,
        serialize: (id) => id.toUrl(),
        deserialize: (url) => OrganizationId.fromUrl(url),
    },
    "OrganizationId"
)
superjson.registerCustom<V1ProjectId, string>(
    {
        isApplicable: V1ProjectId.isProjectId,
        serialize: (id) => id.toUrl(),
        deserialize: (url) => V1ProjectId.fromUrl(url),
    },
    "V1ProjectId"
)
superjson.registerCustom<V2ProjectId, string>(
    {
        isApplicable: V2ProjectId.isProjectId,
        serialize: (id) => id.toUrl(),
        deserialize: (url) => V2ProjectId.fromUrl(url),
    },
    "V2ProjectId"
)
superjson.registerCustom<UserId, string>(
    {
        isApplicable: UserId.isUserId,
        serialize: (id) => id.toUrl(),
        deserialize: (url) => UserId.fromUrl(url),
    },
    "UserId"
)

const transformer = {
    input: {
        serialize: superjson.serialize,
        deserialize: superjson.deserialize,
    },
    output: {
        serialize: superjson.serialize,
        deserialize: superjson.deserialize,
    },
}

export default transformer
